import { useMedia } from 'react-use'

// TODO: when we switch to new layout, kill useIsMobile hook and rename this one to useIsMobile
// TODO: and fix every usage of useIsMobile
export const useIsMobileNew = () => {
  // 1280px is desktop
  // 1279px is the breakpoint for mobile
  const isMobile = useMedia('(max-width: 1279px)')
  return isMobile
}
